function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M53.563 23.569a2.812 2.812 0 002.25-2.754V15A2.812 2.812 0 0053 12.187H8A2.812 2.812 0 005.187 15v5.815a2.812 2.812 0 002.25 2.754 6.563 6.563 0 010 12.862 2.812 2.812 0 00-2.25 2.754V45A2.812 2.812 0 008 47.813h45A2.812 2.812 0 0055.813 45v-5.815a2.812 2.812 0 00-2.25-2.754 6.563 6.563 0 010-12.862zM7.063 45v-5.815a.938.938 0 01.75-.916 8.438 8.438 0 000-16.538.938.938 0 01-.75-.916V15A.937.937 0 018 14.062h14.063v31.876H8A.938.938 0 017.062 45zm39.374-15a8.46 8.46 0 006.75 8.269.938.938 0 01.75.916V45a.938.938 0 01-.937.938H23.937V14.061H53a.938.938 0 01.938.938v5.815a.938.938 0 01-.75.916A8.458 8.458 0 0046.438 30z",
  fill: "#fff"
});

function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTicket;